<template>
<div class="Frame">
    <div class="ShoppingInfoIndex">
        <h2>{{ this.risorse["ModdatiPers"] }}</h2>
        <span v-html="this.risorse['CambioDatiText']"></span>
    </div>
    <div class="ShoppingInfo">
        <ModificaDatiForm></ModificaDatiForm>
    </div>
</div>
</template>

<script>

import ModificaDatiForm from "@/components/ModificaDatiForm.vue";
import {risorseMixin} from "@/mixin.js";

export default {
    name: "UpdateAnagrafica",
    components: {
        ModificaDatiForm
    },
    mixins:[risorseMixin]
}
    
</script>